export default {
    // "m" stand for "message"
    m: {
        confirm: '确定',
        cancel: '取消',
        save: '保存',
        success: '成功',
        tip: '提示',
        operateSuccess: '操作成功！',
        addSuccess: '添加成功！',
        editSuccess: '修改成功！',
        delSuccess: '删除成功！',
        importSuccess: '导入成功！',
        importFail: '导入失败！',
        saveSuccess: '保存成功！',
        delete: '确认删除吗？',
        edit: '确认修改吗？',
        publish: '确认发布此培训计划吗？',
        resetPwd: '确认重置该用户密码? 重置后密码将变更为：',
        coursingOrExit: '当前正在制作课件，确认退出?',
        paperingOrExit: '当前正在制作考卷，确认退出?',
        paperDataNotSave: '当前的试卷数据将不会被保存，确认继续?',
        delCert: '此操作将永久删除该证书, 是否继续？',
        titleRequired: '标题不能为空！',
        submitPaper: '确认提交试卷？',
        submitUndonePaper: '您还有 {0} 道题未作答，是否提交试卷？',
        practiceResult: '本次练习共包含 {0} 题，作答正确 {1} 题',
        endingTime: '取证日期须不得小于发证日期！',
        checkCode: '验证码已经发送到您手机上，请注意查收',
        signOut: '确定退出登录？',
        cycleUser: '确认恢复所选用户吗？',
        deleteUser: '确定永久删除所选用户吗？',
        pleaseComplete: '请填写完整！',
        emptyMenuLogin: '请先为该账户配置菜单数据！',
        startExam: '确认开始考试？',
        startResitExam: '确认开始补考？',
        deleteImg: '确认删除这 {0} 幅图像吗？',
        resit1: '确定增加一次补考吗？',
        resit2: '该考试已允许补考 {0} 次，确定再增加一次补考吗？'
    },
    // "c" stand for "common" 各个组件公共的词条
    c: {
        all: '全部',
        back: '返回',
        confirm: '确定',
        cancel: '取消',
        reset: '重置',
        success: '成功',
        operation: '操作',
        close: '关闭',
        save: '保存',
        input: '输入',
        add: '添加',
        delete: '删除',
        edit: '编辑',
        query: '查询',
        view: '查看',
        preview: '预览',
        publish: '发布',
        unpublish: '取消发布',
        share: '分享',
        select: '选择',
        submit: '提交',
        finish: '完成',
        others: '其他',
        settings: '设置',
        show: '显示',
        size: '大小',
        total: '共',
        to: '至',
        prev: '上一步',
        next: '下一步',
        fail: '未通过',
        yes: '是',
        no: '否',
        NO: '序号',
        none: '无',
        type: '类型',
        status: '状态',
        description: '描述',
        video: '视频',
        audio: '音频',
        image: '图像',
        theory: '理论',
        document: '文档',
        logOut: '退出',
        date: '时间',
        from: '开始时间',
        startTime: '开始时间',
        endTime: '结束时间',
        startDate: '开始日期',
        endDate: '结束日期',
        creator: '创建人',
        creationTime: '创建时间',
        makingTime: '制作时间',
        modificationTime: '修改时间',
        modificationBy: '修改人',
        noData: '暂无数据',
        noMore: '没有更多了',
        difficulty: '难易程度',
        knowledgePoint: '知识点',
        operatorLevel: '适用级别',
        organizations: '组织机构',
        belong: '所属机构',
        trainingType: '培训类别',
        examType: '考核形式',
        position: '岗位',
        occupation: '身份类型',
        userInfo: '个人信息',
        name: '名称',
        username: '姓名',
        gender: '性别',
        phone: '手机号',
        role: '所属角色',
        grade: '技能',
        education: '学历',
        birthday: '出生日期',
        idCardNo: '身份证号',
        idNo: '工号',  //jobNo
        account: '账号',  //accountNo
        downTemplate: '下载模板',
        import: '导入',
        male: '男',
        female: '女',
        desc: '描述',
        coursewareLibrary: '课件库',
        producer: '制作人',
        productionDate: '制作日期',
        modify: '修改',
        making: '制作',
        resourceName: '资源名称',
        problemNo: '题号',
        right: '对',
        wrong: '错',
        error: '异常',
        notAvailable: '暂无',
        detail: '详情',
        option: '选项',
        check: '勾选',
        noticeHoverTitle: '消息通知',
        noticeTitle: '通知',
        noticeNone: '暂无通知',
        noticeClear: '清空通知',
        upTrend: '上传趋势(近一月)',
        trainAnalyse: '培训任务数据分析(近一月)',
        quickEntry: '快捷入口',
        seeMore: '查看更多',
        trainFinish: '培训计划完成情况',
        toEnd: '距离结束',
        day: '天',
        hour: '小时',
        viewDetail: '查看详情',
        recentWeek: '最近一周',
        miles: '米',
        open: '打开',
        exam: '考试',
        practice: '练习',
        learn: '学习',
        completeTime: '完成时间',
        notYet: '还未获得哦',
        notGet: '暂未获得',
        lookForward: '开发中，敬请期待......',
        yearTime: '年度',
        employmentDate: '入职时间',
        imageLearn:'识图数量',
        studyTime:'学习时长',
        learningStatistics:'学情统计',
        exportLearnStats:'导出学情统计',
        clear:'清空选择',
        moment: '刚刚',
        yearAgo: '年前',
        monthAgo: '月前',
        weekAgo: '周前',
        dayAgo: '天前',
        hourAgo: '小时前',
        minuteAgo: '分钟前',
        month: '月',
        unset: '未设置',
        enabled: '已开启',
        fiscan: '职鉴',
    },
    tip: {
        select: '请选择',
        input: '请输入内容',
        name: '请输入名称',
        sysName: '请输入系统名称',
        sysEnName: '请输入系统英文名称',
        sysShortName: '请输入系统简称',
        sysVersion: '请输入系统版本',
        knowledgePoint: '请选择知识点',
        operatorLevel: '请选择适用级别',
        belong: '请选择所属机构',
        trainingType: '请选择培训类别',
        examType: '请选择考核形式',
        orgName: '请输入机构名称',
        userSearch: '请输入姓名、账号',
        userSearchPlus: '请输入姓名、账号、手机号',
        username: '请输入用户名称',
        usernameOrNo: '请输入用户姓名或编号',
        usernameOrAccount: '请输入用户姓名或账号',
        idNo: '请输入工号',
        occupation: '请选择身份类型',
        grade: '请选择技能',
        position: '请选择岗位',
        gender: '请选择性别',
        birthday: '选择出生日期',
        idCardNo: '请输入身份证号',
        education: '请选择学历',
        path: '请输入路径名称',
        icon: '请输入图标类名',
        NO: '请输入序号',
        remark: '请输入备注',
        time: '请选择时间',
        date: '请选择日期',
        datetime: '选择日期时间',
        startTime: '选择开始日期',
        endTime: '选择结束日期',
        employmentDate: '选择入职时间',
        reason: '请选择原因',
        courseName: '请输入课件名称',
        producer: '请输入制作人',
        courseType: '请选择课件类型',
        hours: '请输入学时',
        credits: '请输入学分',
        addImg: '请添加图像',
        problemNo: '请输入题号',
        creator: '请输入创建人',
        difficulty: '请选择难易程度',
        titleDesc: '请输入题目描述',
        chooseRightAnswer: '请选择正确答案',
        optionDesc: '请填写选项描述',
        paperName: '请输入考卷名称',
        paperGroupType: '请选择组卷方式',
        passLine: '请输入及格线',
        questionScore: '请输入考题分值',
        paperType: '请输入考卷类型',
        paperForm: '请输入考卷形式',
        perspective: '请选择视角',
        account: '请输入账号',
        trainerName: '请输入学员姓名',
        transcriptTitle: '请输入成绩单标题',
        word: '请输入文字',
        title: '请输入标题',
        option: '请输入选项内容',
        trainName: '请输入培训计划名称',
        oldPwd: '请输入旧密码',
        newPwd: '请输入新密码',
        confirmPwd: '请再次输入新密码',
        mobile: '请输入手机号',
        code: '请输入验证码',
        untie: '请输入手机验证码来解除绑定',
        chooseGroupType: 'CT类型暂不支持快速组卷，请重新选择组卷方式',
        txtContent: '内容区...',
        resName: '请输入资源名称',
        imgUploadMaxSize: '图片大小不能超过{0}M',
        fileUploadMaxSize: '文件大小不能超过{0}M',
        fileExceedTip: '当前限制选择 {0} 个文件，本次选择了 {1} 个文件，共选择了 {2} 个文件',
        chooseOrgFirst: '请先选择组织机构',
        queryOrg: '查询组织机构',
        chooseDueDate: '请选择截止时间',
        chooseTopicSource: '请选择考题来源',
        uploader: '请输入上传人',
        knowTagTip: '请输入标签',
        knowTypeTip: '请选择知识类型',
        knowNameTip: '请输入知识名称',
        knowDescTip: '请输入知识描述',
        tipStart:'请选择开始时间',
        tipEnd:'请选择结束时间',
        type: '请选择类型',
    },
    rule: {
        lengthBetween: '长度在{0}到{1}个字符之间',
        maxLength: '长度不能超过{0}个字符',
        idCardNo: '请输入正确的身份证号码',
        required: '请填写此项',
        int: '值不能为小数',
        time: '时间需晚于当前时间',
        pwd: '密码规则：12到20位，数字、字母及部分特殊字符_-#@&?*^=!.$%的组合',
        pwdError: '不符合密码规则，请重新填写',
        mobileNotExist: '该手机号不存在！',
        mobileHasBound: '该号码已绑定其他账号',
        modifyPwd:'请修改密码！',
        codeError: '只支持_-#@&?*^=!.$%等特殊字符',
    },
    system: {
        sysName: '系统名称',
        sysEnName: '系统英文名称',
        sysShortName: '系统简称',
        sysVersion: '系统版本',
        sysLogo: '系统Logo',
        editSysLogo: '修改系统logo',
        addOrg: '新增机构',
        orgDetail: '组织机构详情',
        orgName: '机构名称',
        orgDesc: '机构描述',
        addUser: '添加用户',
        importUser: '导入用户',
        editUser: '修改用户',
        cycleUser: '用户回收',
        recoverUser: '恢复用户',
        deleteUser: '删除用户',
        modifyRole: '修改角色',
        manageRole: '管理角色',
        addRole: '添加角色',
        delRole: '删除角色',
        resetPwd: '重置密码',
        unselected: '未选择',
        selected: '已选择',
        changeAvatar: '修改我的头像',
        userProfile: '用户档案',
        trainRecord: '培训记录',
        skillRecord: '技能鉴定',
        result: '结果',
        certificateName: '证书名称',
        certAdd: '添加证书',
        certDetail: '证书详情',
        certificateNo: '证书编号',
        level: '评定等级',
        operateScore: '操作成绩',
        theoryScore: '理论成绩',
        releaseDate: '颁发日期',
        editMenu: '修改菜单',
        addMenu: '添加菜单',
        addSubmenu: '添加子菜单',
        parent: '上级',
        path: '路径',
        icon: '图标',
        roleName: '角色名称',
        manageMember: '配置成员',
        manageMenu: '配置菜单',
        allMembers: '全部成员',
        memberList: '成员列表',
        selectedMember: '已选人员',
        theoryKnowledge: '理论知识点',
        imageKnowledge: '图像知识点',
        remark: '备注',
        exportUser: '导出用户(根据上方筛选条件)',
        preJobApproval: '开岗放权',
        capabilityAnalyse: '能力分析图',
        enabled: '正常',
        disabled: '禁用',
        projectType: '项目类别',
        importOrg: '导入组织机构',
        exportOrg: '导出组织机构',
        move: '移动'
    },
    user: {
        basicInfo: '基本信息',
        postInfo: '岗位信息',
        experienceInfo: '工作经历',
        trainInfo: '培训记录',
        qualityInfo: '质控记录',
        rewardInfo: '奖惩信息',
        modifyInfo: '修改记录',
        importDiploma: '导入毕业证照片',
        exportBasicInfo: '导出基本信息',
        exportExtendInfo: '导出详细信息',
        userImportTemplate: '用户导入模板',
        userBasicImportTemplate: '用户基本信息模板',
        userExtendImportTemplate: '用户详细信息模板',
        zipImportTemplate: '压缩包样例文件',
        clickToDownload: '点击下载',
        chooseToDownload: '选择以下任一模板进行下载：',
        startImport: '开始上传',
        unbind: '未绑定',
        bindTip: '需要用户自行绑定',
        nation: '民族',
        hometown: '籍贯',
        currentAddress: '现居住地址',
        graduationSchool: '毕业院校',
        graduationDate: '毕业日期',
        graduationDateTip: '请选择毕业日期',
        jobDate: '参加工作时间',
        jobDateTip: '请选择参加工作时间',
        securityCheckJobDate: '参加安检工作时间',
        securityCheckJobDateTip: '请选择参加安检工作时间',
        employmentDate: '入职时间',
        employmentDateTip: '请选择入职时间',
        diplomaPicture: '毕业证及学位照片',
        downloadFile: '下载附件',
        duty: '职务',
        jobTitle: '职称',
        backgroundReview: '背景审核情况',
        certTip: '需在“证书管理”中为该用户添加证书',
        startEndTime: '起止时间',
        companyName: '公司名称',
        addWorkExperience: '新增工作经历',
        editWorkExperience: '编辑工作经历',
        addQuality: '新增质控记录',
        editQuality: '修改质控记录',
        cause: '事由',
        dealResult: '处理/奖励情况',
        addReward: '新增奖惩信息',
        editReward: '编辑奖惩信息',
        rewardDetail: '具体奖惩情况',
        punish: '惩罚',
        reward: '奖励',
        module: '模块',
        ledgerRecord: '台账记录',
    },
    train: {
        name: '培训名称',
        type: '培训类别',
        percent: '培训进度',
        memberNum: '培训人数',
        site: '培训地点',
        classHour: '培训学时',
        classScore: '培训学分',
        content: '培训内容',
        time: '计划时间',
        checkInTime: '签到时间',
        preTime: '预发布时间',
        dueTime: '截止时间',
        addOnlineTrain: '新增线上培训',
        addOfflineTrain: '新增线下培训',
        associatePaper: '关联调查问卷',
        choosePaper: '选择调查问卷',
        paperName: '调研问卷名称',
        surveyName: '问卷名称',
        confirmPublish: '确定发布？',
        newOnlineTraining: '制定线上培训计划',
        newOfflineTraining: '制定线下培训计划',
        editTraining: '修改培训计划',
        basicInfo: '基本信息',
        trainees: '参训人员',
        courseSystem: '课程体系',
        chooseCourse: '选择课件',
        chooseTestPaper: '选择考卷',
        chooseMockPaper: '选择模拟考试',
        chooseTip: '请添加环节',
        testPeriod: '请输入考试时长',
        editPaperTip: '请对考卷进行编辑',
        addSuccess: '培训计划添加成功！',
        editSuccess: '培训计划修改成功！',
        trainDetail: '培训计划详情',
        trainTrace: '培训完成情况',
        planDetail: '培训记录详情',
        progress: '当前进度',
        progressNow: '当前完成进度',
        delTrainee: '将此人移出计划',
        delTraineeConfirm: '确认将 {0} 移出培训计划吗?',
        // addTrainee: '添加培训人员',
        addTrainee: '添加人员',
        reason: '原因',
        absentReason: '缺席原因',
        casualLeave: '事假',
        sickLeave: '病假',
        annualLeave: '年假',
        parentalLeave: '产假',
        maternityLeave: '孕假',
        paternityLeave: '陪产假',
        passiveFinish: '被动完成',
        credit: '学分',
        hour: '学时',
        times: '次',
        resitTimes: '次数',
        qrCode: '生成二维码',
        enlarge: '展开/折叠表格',
        endDate: '结束日期（不填则永久有效）',
        trainPlan: '培训计划',
        signArea: '签到区域',
        signPoint: '打卡点',
        userStatus: '用户状态',
        trainingMode: '培训模式',
        currentOrg: '当前选中机构',
        clickOrgFirst: '请先点击左侧的组织机构,并选择截止截止时间',
        checkAllMembers: '对全部成员进行以下操作',
        advancedSettings: '高级设置',
        advancedAccount: '请输入学员账号或工号，用空格或换行隔开',
        advancedMaxError: '请不要超过 1000 个账号！',
        extendEndTime: '延长结束时间',
        extendTip1: '结束时间不能小于当前日期',
        extendTip2: '取消结束时间设置，将无限期延长培训计划',
        extendRule: '规则',
        clonePlan: '克隆培训计划',
        cloneTip1: '培训计划中的参训人员不会被克隆',
        cloneTip2: '如未填写培训计划名称，默认使用被克隆的培训计划名称',
        cloneSuccess: '克隆成功!',
        group: '所属群组',
        groupManage: '群组管理',
        groupName: '群组名称',
        groupAdd: '添加群组',
        groupEdit: '修改群组',
        pushMessage: '推送消息',
        surePushMessage: '确定此培训计划发推送消息吗？',
        pushSuccess: '推送消息成功！'
    },
    course: {
        course: '课件',
        name: '课件名称',
        type: '课件类型',
        sectionCannotDisplay: '该章节资源暂时不能显示',
        theoryCourseware: '理论课件',
        chapter: '章节',
        theChapter: '第 {0} 章', // 重点翻译
        viewing: '当前查看',
        myCourse: '我的课件',
        theoryCoursewareMake: '理论课件制作',
        theoryCoursewareEdit: '理论课件编辑',
        imageCoursewareMake: '图像课件制作',
        imageCoursewareEdit: '图像课件编辑',
        imageCourseware: '图像课件',
        addBaseInfo: '添加基本信息',
        addChapter: '添加章节',
        addImage: '添加图像',
        courseCover: '课件封面',
        addCover: '添加封面',
        deleteCover: '删除封面',
        coverTip: '注：封面图片大小不超过{0}M',
        coverTooBigMsg: '上传封面图片大小不能超过 2MB!',
        courseDesc: '课件描述',
        courseNoImg: '当前课件暂无图像，点击按钮，添加图像',
        imageName: '图像名称',
        addImageDesc: '图像描述添加：',
        addImageDescInfo: '请添加该图像描述信息...',
        courseMakeSuccess: '课件制作成功!',
        curriculumSystem: '课程体系',
        chapterTitle: '请输入章标题',
        sectionTitle: '请输入节标题',
        resourceSelection: '资源选择',
        fileUpload: '文件上传',
        fastForward: '可快进',
        noFastForward: '不可快进',
        learningTime: '学习时长',
        terminateUpload: '终止上传',
        imageUpload: '图片上传',
        documentUpload: '文档上传',
        videoUpload: '视频上传',
        audioUpload: '音频上传',
        fileUploadFail: '文件上传失败，请重新上传',
        courseEditSuccess: '课件修改成功!',
        marquee: '是否开启走马灯',
        marqueeText: '请输入走马灯内容',
        min: '分钟',
        addTip: '注：鼠标锁定到章节名称输入框，点击回车添加章节',
        sectionDes: '请输入该节描述...'
    },
    topic: {
        name: '考题名称',
        examPaperLibrary: '考题库',
        detailView: '详情视图',
        listView: '列表视图',
        useTimes: '使用次数排序',
        rightRateSort: '正确率排序',
        rightRate: '正确率',
        default: '默认排序',
        papersAssembleTimes: '组卷次数',
        papersTimesSort: '组卷次数排序',
        papersAssembled: '已组卷次数',
        answerAnalysis: '答案解析',
        imageDesc: '图像描述',
        questionDesc: '题目描述',
        myTopic: '我的考题',
        addTopic: '添加考题',
        editTopic: '编辑考题',
        optionDesc: '选项描述',
        rightOption: '正确选项',
        addOrEditAnalyse: '添加/修改答案解析',
        simulatedBag: '模拟箱包',
        emptyPacket: '空包',
        dangerous: '危险品',
        chooseImage: '选择图像',
        addTopicDesc: '点击添加答案解析',
        insertTip: '插入TIP',
        editSaveSuccess: '编辑保存成功!',
        passLine: '及格线',
        mockPassLine: '通过线',
        leastOne: '请至少选择一道考题',
        addTopicByPic: '导入图片生成判断题',
        excelDown: 'Excel模板下载',
        excelImport: 'Excel导入',
        wordDown: 'Word模板下载',
        wordImport: 'Word导入',
        tipAdjust: 'Tip调节',
        tipAdjustPanel: 'Tip调节控制面板',
        zoom: '缩放',
        rotate: '旋转',
        physicalMap: '实物图',
        attention: '注意事项',
        tipInsertAttention1: '1. 请不要对双视角的箱包中插入的Tip进行缩放旋转操作',
        tipInsertAttention2: '2. 如果Tip图像在缩放或旋转的过程中超出箱包图像，请手动进行拖动调整',
        tipInsertAttention3: '3. Tip缩放请选择一个合理的范围，尽量和实际情况相符',
        answerLabelType: '答案标注类型',
        clickUpload: '点击上传'
    },
    paper: {
        paper: '考卷',
        myPaper: '我的考卷',
        theoryPaper: '理论考卷',
        theoryPaperMake: '理论考卷制作',
        theoryPaperEdit: '理论考卷编辑',
        imagePaper: '判图考卷',
        imagePaperMake: '判图考卷制作',
        imagePaperEdit: '判图考卷编辑',
        name: '考卷名称',
        type: '考卷类型',
        form: '考卷形式',
        paperMethod: '组卷方式',
        testPeriod: '考试时长(分钟)',
        publishTime: '答案公布时间',
        publishTimeTip: '如果不选择，则答完立即公布答案',
        allowReview: '可回查答案',
        allowResit: '允许补考',
        allowResitTimes: '允许补考次数',
        resatTimes: '已补考次数',
        keyResit:'一键补考',
        resitSuccess: '补考成功！',
        leaveTimes: '切屏次数',
        disorder: '考题乱序',
        faceMatching: '人脸比对',
        photoDuration: '监考拍照频率',
        secondPerTime: '秒/次',
        questionType: '题型',
        single: '单选题',
        multiple: '多选题',
        trueOrFalse: '判断题',
        matching: '配对题',
        graphic: '图片题',
        buildupSmart: '智能组卷',
        buildupChoose: '选题组卷',
        buildupImport: '导入组卷',
        passScore: '及格分',
        passingMark: '及格分数',
        totalScore: '总分',
        paperLibrary: '考卷库',
        paperScore: '考卷分数',
        editPaper: '编辑试题',
        startPaper: '开始组卷',
        randomGenPaper: '根据设置的组卷条件，从题库中随机选题，生成一套试卷',
        chooseGenPaper: '勾选理想题目组成一套试卷',
        importGenPaper: '导入Word、Excel模板，或者手动录入，快速生成考卷',
        chooseImportType: '选择导入方式',
        wordImport: 'Word导入',
        wordUpload: '上传Word',
        excelImport: 'Excel导入',
        excelUpload: '上传Excel',
        clickBtnAddTopic: '当前试卷没有任何题目，点击按钮，添加试题',
        addTopic: '添加试题',
        totalQuestions: '总题数',
        totalScores: '总分数',
        points: '分',
        reimport: '重新导入',
        previewPaper: '考卷预览',
        savePaper: '保存考卷',
        answer: '答案',
        analysis: '解析',
        keyQuestion: '关键题',
        keyQuestionAccuracy: '关键题正确率',
        backToTop: '回到顶部',
        chooseTopic: '选择试题',
        topicSource: '考题来源',
        source: '来源',
        editPaperSuccess: '考卷修改成功',
        theoryPaperMakeSuccess: '理论考卷制作成功',
        imagePaperMakeSuccess: '图像考卷制作成功',
        difficultDistribution: '难易分布',
        simple: '简',
        medium: '中',
        hard: '难',
        questionQuantity: '题量',
        scorePerQuestion: '每题分数',
        singleTotalNum: '单选题(共 {0} 道)',
        multipleTotalNum: '多选题(共 {0} 道)',
        judgeTotalNum: '判断题(共 {0} 道)',
        knowledgeTotalNum: '知识点(共 {0} 道)',
        emptyPacketTotalNum: '空包(共 {0} 道)',
        otherTotalNum: '其他(共 {0} 道)',
        selectYourTopic: '选择 {0} 试题',
        paperNumGtOne: '考卷至少要包含一道考题',
        paperNeddIncludeOneKP: '考卷至少要包含一道知识点考题',
        smartGroupSuccess: '智能组卷成功',
        imageTopic: '图像题',
        dao: '道',
        eachTopic: '每题',
        setKeyTopic: '设置关键题',
        accuracyRate: '正确率',
        buildupFast: '快速组卷',
        tipGenPaper: '自动插入TIP，快速生成考核试卷',
        safeBag: '安全包裹',
        selectKPTip: '点击右侧选择知识点类型',
        ge: '个',
        emptyNum: '空包数量',
        dangerNum: '危险品数量',
        simulatedNum: '模拟箱包数量',
        warnEmpty: '请输入安全包裹数量',
        showAnswerAfterExam: '考完后公布',
        mock: '模拟考试',
        mockTimes: '模拟考试次数',
        chooseKpFirst: '请先选择知识点类型',
        exportPaper: '导出考卷',
        imgSourceTip: '请选择图像来源'
    },
    // 全屏的考试/练习页
    exam: {
        totalCount: '本试卷包含',
        question: '题',
        min: '分钟',
        score: '成绩',
        period: '答题时间',
        answerSheet: '答题卡',
        singleMode: '单题模式',
        multiMode: '多题模式',
        correct: '正确',
        incorrect: '错误',
        answered: '已作答',
        blank: '未作答',
        viewAnswer: '查看答案',
        prev: '上一题',
        next: '下一题',
        submit: '结束作答',
        practiceTitle: '理论练习',
        loading: '加载中...',
        result: '考试结果',
        practiceResult: '练习结果',
        paperCount: '本试卷共有',
    },
    //图库、资源管理
    res: {
        imgName: '图像名称',
        imgType: '图像类型',
        imgDesc: '图像描述',
        perspective: '视角',
        singleView: '单视角',
        doubleView: '双视角',
        sideView: '侧视角',
        imgOrigin: '图像来源',
        file: '文件',
        fileView: '文件视图',
        listView: '列表视图',
        viewCT: '查看CT',
        viewDR: '查看DR',
        lastFile: '上一个文件',
        nextFile: '下一个文件',
        editImg: '修改图像信息',
        resName: '资源名称',
        resType: '资源种类',
        checkAll: '全选',
        cancelCheckAll: '取消全选',
        allFiles: '全部文件',
        upload: '上传',
        uploadTime: '上传时间',
        rename: '重命名',
        progress: '执行中...',
        renameSuccess: '重命名成功！',
        newFolder: '新建文件夹',
        folderNameTip: '请输入文件夹名称',
        folderNameIs: '文件夹名称为：',
        newFolderSuccess: '新建成功！',
        uploadStep: '上传流程',
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: '已暂停',
        waiting: '等待上传',
        delete: '删除',
        fileList: '文件列表',
        chooseFile: '选择文件',
        expand: '展开',
        fold: '折叠',
        noUploadFile: '暂无待上传文件',
        checkMD5: '校验MD5',
        transcoding: '转码中',
        merging: '合并中',
        uploadFail: '上传失败',
        copyTo: '复制到',
        moveTo: '移动到',
        refresh: '刷新',
        fileTotal: '共{0}个文件',
        fileSize: '文件大小',
        playAudio: '播放音频',
        syncToLibrary: '同步到图像库',
        bag: '包裹',
        editImage: '修改图像',
        isTip: '是否为单个危险品',
        isDeleteAfterTB: '是否删除图像',
        synchSuccess: '同步成功！',
        deleteMulti: '确认删除这{0}个文件吗？',
        fiscanImage: '一所图像统计详情',
        nuctechImage: '威视图像统计详情',
        copy: '复制图像',
        move: '移动图像',
        selected: '已选中{0}项',
        standardLib: '标准图库',
        userLib: '个人图库',
        addNode: '添加节点',
        shareFrom: '来自{share}的分享',
        editNode: '编辑节点',
        addChildNode: '新增子节点',
        nodeName: '节点名称',
        nodeType: '节点类型',
        folder: '文件夹',
        imgFile: '图像文件夹',
        selectImgFile: '请选择图像文件夹',
        selectMember: '选择人员',
        moveSuccess: '移动成功！',
        copySuccess: '复制成功！',
        shareSuccess: '分享成功！',
        sureDelFile: '确认删除{file}文件吗？',
        sureDelImgFile: '确认删除{file}文件吗？若删除，该图像文件夹所含图像也将删除',
        currentCheckNode: '当前图像位置',
        checkNodeTip: '请点击左侧图像文件夹',
        addKnowledge: '添加知识',
        knowName: '知识名称',
        knowType: '知识类别',
        knowTag: '知识标签',
        knowDesc: '知识描述',
        pageViews: '浏览量',
        comments: '评论量',
        likes: '点赞量',
        allSee: '所有人可见',
        someSee: '部分人可见',
        uploader: '上传人',
        visibleRange: '设置可见范围',
        knowTagTip: '标签是便于查找和管理的工具，多标签请用逗号分隔',
        visiblePerson: '可见人员',
        updateSystemTree: '更新标准图像库',
        noAccessToDelete: '无权限删除选中的所有图像',
        filterDelete: '将自动过滤掉 {0} 个无权限删除的图像',
        tipLib: '元素图像库',
        bagLib: '包裹图像库',

    },
    cert: {
        holder: '持证人',
        type: '证书类型',
        date: '日期',
        number: '编号',
        issueDate: '签发日期',
        reviewDate: '复审日期',
        retrainDate: '复训日期',
        releaseDate: '发证日期',
        obtainDate: '取证日期',
        addCert: '添加证书',
        downCertTemp: '下载证书模板',
        upLoadCertTemp: '导入证书',
        upLoadCertPic: '导入证书照片',
        exportCertTemp: '导出证书',
        downCertRetrain: '下载复训模板',
        upLoadCertRetrain: '导入复训记录',
        exportCertRetrain: '导出复训记录',
        editCert: '编辑证书',
        dangerCert: '危险品证书',
        proCert: '职业资格证书',
        juniorProCert: '初级职业资格证书',
        IntermediateProCert: '中级职业资格证书',
        seniorProCert: '高级职业资格证书',
        technicianProCert: '技师职业资格证书',
        technicianProPlusCert: '高级技师职业资格证书',
        certManage: '证书管理',
        certAddTip: '为此人添加证书',
        certAddTip_1: '请在左侧为此人添加证书',
        howToTip: '请在左侧选择持证人，然后为其添加证书',
        selectHolderTip: '请选择持证人',
        certInfo: '证书详情',
        certName: '证书名称',
        certNum: '证书编号',
        theoryScore: '理论成绩',
        operationScore: '操作成绩',
        gradeName: '评定成绩',
        retrain: '复训',
        retrainRecord: '复训记录',
        retrainGrade: '复训成绩',
        obtainCert: '获得证书',
        trainSubject: '训练课目',
        trainInstitution: '训练机构',
        trainerName: '教员姓名',
        personType: '人员类别',
        trainConclusion: '考核结论',
        qualified: '合格',
        good: '良好',
        excellent: '优秀',
        addRecord: '添加记录',
        editRecord: '编辑记录',
        selectUser: '选择用户',
        junior: '初',
        Intermediate: '中',
        senior: '高',
        technician: '技',
    },
    count: {
        quantity: '数量',
        certMember: '证书人员详情',
        viewType: '视角类型',
        singleView: '单视角',
        dualView: '双视角',
        frequency: '使用次数',
        resType: '资源类型',
        uploadRank: '上传数量排名',
        uploadNum: '上传数量',
        courseNum: '课件数量',
        theory: '理论',
        topicType: '考题类型',
        topicDetail: '考题详情',
        topicNo: '考题编号',
        examName: '考试名称',
        examDuration: '考试时间',
        score: '分数',
        peopleNum: '人数',
        totalPeopleNum: '总人数',
        passRate: '及格率',
        passScore: '及格分',
        averageScore: '平均分',
        lowest: '最低分',
        highest: '最高分',
        examAttend: '应考',
        attend: '已考',
        examRealAttend: '实考',
        absent: '缺考',
        examAbsence: '缺考',
        passed: '及格',
        examPassNum: '及格人数',
        failed: '不及格',
        examFailNum: '不及格人数',
        countAnalysis: '统计分析',
        paperScoreStatistic: '试卷成绩统计',
        examDetailTitle: '考试详情统计图',
        wrongRateTitle: '考题错误率统计',
        rightNum: '正确题数',
        wrongNum: '错误题数',
        wrongRate: '错误率',
        scoreRank: '学员成绩',
        transcript: '成绩单',
        exportStuDetail: '导出学员作答详情',
        exportTranscript: '导出成绩单',
        exportOffline: '导出培训名单',
        print: '打印',
        printReview: '打印预览',
        exportDate: '导出日期',
        timeConsume: '用时',
        submitTime: '提交时间',
        ranking: '名次',
        rankStatisticsTitle: '成绩排名统计',
        rankRangeTitle: '成绩分布统计',
        feedback: '调研反馈',
        trainDetailTitle: '培训详情统计',
        numStatistics: '数量统计',
        studyDuration: '学习时间',
        studyTime: '学习时长',
        studyNum: '学习总数',
        min: '分',
        s: '秒',
        personalStudyTitle: '个人学习情况统计',
        finish: '完成',
        unfinish: '未完成',
        notStart: '未开始',
        processing: '进行中',
        absence: '缺席',
        recover: '恢复',
        registered: '已报名',
        normal: '正常',
        late: '迟到',
        error: '异常',
        studentStatus: '状态',
        knowErrorRate: '知识点错误率',
        knowErrorRateStat: '知识点错误率统计',
    },
    survey: {
        name: '调研名称',
        add: '添加调研问卷',
        edit: '编辑调研问卷',
        desc: '调研描述',
        topic: '调研题目',
        addOption: '添加选项',
        addTitleTip: '点此添加题目',
        subjective: '主观题',
        star1: '很不满意',
        star2: '不满意',
        star3: '一般',
        star4: '满意',
        star5: '非常满意',
        responseNum: '回答人数',
        percentage: '百分比',
        detail: '问卷详情',
        statisticsTitle: '培训调研问卷统计',
        publisher: '发布者',
        validNum: '有效答卷数',
        satisfaction: '整体满意度',
        proportion: '比例',
        synthesis: '综合',
        appraised: '未评价（0）',
        average: '平均分：'
    },
    questionnaire: {
        name: '问卷名称',
        add: '添加调查问卷',
        edit: '编辑调查问卷',
        desc: '问卷描述',
        topic: '题目',
        starTopic: '评分题',
        startSurvey: '发起调查',
        peopleNum: '参与人数',
        defaultReport: '默认报告',
        replyStatistics: '答卷统计',
        NO: '第{0}道题',
        filterEmpty: '过滤空选项',
        replyTime: '作答时间',
        replyTxt: '作答文本',
        viewPaper: '查看答卷',
        startSuccess: '发起成功!',
        maxLimit: '最多选{0}项',
        open: '打开调查',
        close: '关闭调查',
        export: '导出问卷',
        confirmOpen: '确认打开调查吗？',
        confirmClose: '确认关闭调查吗？',
        successOpen: '打开成功！',
        successClose: '关闭成功！',
    },
    // 学员模块
    stu: {
        unfinished: '未完成',
        finished: '已完成',
        studyProgress: '学习进度',
        viewCourse: '查看课件',
        enterStudy: '进入学习',
        continueStudy: '继续学习',
        viewPaper: '查看考卷',
        enterExam: '进入考试',
        continueExam: '继续考试',
        enterMock: '进入模拟考试',
        startResit: '开始补考',
        resitStatus: '补考状态',
        resat: '已补考',
        allowResit: '允许补考',
        loadingExamTip: '加载试卷中...',
        serverError: '服务器开小差了~',
        loadPaperError: '加载考卷数据失败！',
        topicNum: '题目数量',
        startPractice: '开始练习',
        startStudy: '开始学习',
        timeSetting: '时间设置',
        set: '设置',
        notSet: '不设置',
        singleTopic: '单题',
        wholePaper: '整卷',
        practiceMode: '练习模式',
        quickJudge: '快速判断',
        markLocation: '位置标记',
        markLocationAndJudge: '位置标记及类型选择',
        pass: '通过',
        passed: '已通过',
        failed: '未通过',
        passRate: '通过率',
        theoryPractice: '理论练习',
        imgPractice: '图像练习',
        practiceDate: '练习时间',
        timeoutNum: '超时数量',
        trainTask: '培训任务',
        personal: '摘要统计',
        trainNum: '培训数量',
        testNum: '考试数量',
        exciseNum: '练习次数',
        imageNum: '识图次数',
        errorStatistics: '错题统计',
        isPass: '及格情况',
        testPass: '考试结果统计',
        courseStudy: '课件学习统计',
        imageAbility: '识图能力分析',
        theoryKP: '理论知识点',
        imageKP: '图像知识点',
        taskName: '任务名称',
        intoTask: '进入任务',
        imgPracticeTip1: '一、快速判断模式可以直接使用快捷键【>】、【?】进行"通过"或"不通过"的判图',
        imgPracticeTip2: '二、非快速判断练习模式下，判图为"危险"只能通过手动标记嫌疑物进行判断',
        imgPracticeTip3: '三、设置答案不可修改选项后，只能对激活(有闪烁点)图像进行判图',
        imgPracticeTip4: '四、走图过程中不会一直保留之前图像，对于已经删除的图像不支持再修改答案的操作',
        imgPracticeTip5: '五、速度切换【1,2,3】, 双击标记嫌疑框大小切换【z,x,c】, 暂停开始【空格】切换',
        walkingPictureSetting: '走图配置',
        answerCanModify: '答案可修改',
        answerCannotModify: '答案不可修改',
        slow: '较慢',
        normal: '正常',
        fast: '较快',
        suspectColor: '标框颜色',
        speed: '走图速度',
        pracitceNote: '练习注意',
        theoryAndImgPractice: '理论与识图练习',
        continuePractice: '继续练习',
        newPractice: '开始新练习',
        unsubmitPracticeTip: '当前练习数据未提交，是否继续当前练习？',
        imgStudyMenu: '识图学习',
        imgPracticeMenu: '识图练习',
        trackPracticeMenu: '走图练习',
        submitDate: '提交日期',
        images: '图像数量',
        resultpf: '结果',
        historyMockPaper: '历史考卷',
        enterExamTip: '考试一旦开始，中途退出可能会导致没有成绩，影响考试结果，请做好考试准备。',
        creditsEarned:'已获学分',
        totalCredit: '总学分',
        monthCredit: '当月学分',
        allRank: '全部排名',
        orgRank: '同机构排名',
        creditDetail: '学分明细',
        watchCreditDetail: '学分明细',
        rankList: '排行榜',
        watchRankList: '查看排行榜',
        myCreditRecord: '我的学分记录',
        rank: '排名',
        noRank: '暂无排名'
    },
    prejob: {
        colorBlind: '色盲色弱',
        colorSensitive: '颜色敏感度',
        spatialIntelligence: '空间想象力',
        basicKnowledge: '基本知识',
        dailyItems: '生活物品',
        dangerItems: '危险物品',
        testTip: '测试提醒',
        startTest: '开始测试',
        quitTest: '放弃测试',
        submitTest: '提交测试',
        tipDoNotClose: '温馨提示：答题过程中请不要关闭考卷页面',
        tipOneChance: '仅一次测试机会，请认真对待哦~',
        forReference: '注：此测试结果并不代表权威',
        tipProgress: '完成所有的测试即可查看测评结果',
        cheerUp: '加油吧~',
        viewReport: '查看测评报告',
        reportTitle: '智能测评报告',
        rating: '测评等级',
        weakness: '薄弱知识点',
        accuracy: '正答率',
        assessTitle: '平台已根据您的测评数据分析出了如下结果',
        assessPerfect: '完美的掌握了{0}',
        assessGood: '大致掌握了{0},需要再接再厉',
        assessBad: '{0}掌握较差,需要加强训练',
        assessCheerUp: '加油哦，您会成为一名优秀的安检员~',
        notDone: '尚未完成岗前测评'
    },
    http: {
        error: '网络异常',
        forbidden: '禁止访问：Forbidden',
        serverError: '服务器异常',
        timeout: '请求超时'
    },
    app: {
        login: '登录',
        portal: '门户网站',
        mobileSite: '手机端登录',
        switchTheme: '切换主题风格',
        signOut: '退出登录',
        changePwd: '修改密码',
        oldPwd: '旧密码',
        newPwd: '新密码',
        confirmPwd: '确认新密码',
        errorPwd: '两次输入密码不一致!',
        bindMobile: '绑定手机',
        mobile: '手机号',
        code: '验证码',
        getCode: '获取验证码',
        getCodeAgain: '重新获取',
        waitCode: '{0}s 后重新获取',
        bound: '您已绑定手机号',
        unbound: '该手机号尚未绑定用户',
        untie: '解除绑定',
        errorMobile: '请输入正确的手机号码',
        bindSuccess: '绑定成功!',
        untieSuccess: '解绑成功!',
        account: '请输入账号或手机号',
        jobNo: '请输入工号',
        enterpriseCode: '请输入企业编码',
        roleType: '请选择身份类型',
        admin: '管理员',
        trainer: '培训师',
        student: '学员',
        pwd: '请输入密码',
        logining: '登录中',
        loginNow: '立即登录',
        forgetPwd: '忘记密码？',
        retrievePwd: '找回密码',
        pwdLogin: '密码登录',
        scanLogin: '扫码登录',
        smsLogin: '短信登录',
        jobNoLogin: '工号登录',
        faceLogin: '人像登录',
        faceLoginClick: '请点击，进行人像识别登录',
        confirmEdit: '确认修改',
        resetSuccess: '您的密码已重置完成，{0}s 后将自动跳转至登录界面',
        scanSuccess: '扫码成功',
        qrInvalid: '二维码已失效',
        freshQR: '刷新二维码',
        scanLoginTip: '扫一扫登录',
        appName: '威视安培云',
        dashboard: '主 页',
        track: {
            trackTip: '检测过程中请不要刷新或关闭页面，建议保持五官清晰',
            envMonitoring: '环境监测中...',
            faceMonitoring: '人像监测中，请注视摄像头',
            liveMonitoring: '人像捕获成功，活体验证中...',
            camera: '{0} 秒后拍照，请保持注视',
            checking: '验证中...',
            loginSuccess: '登录成功！'
        },
        copyright: '版权所有 © 2019 All Rights Reserved 同方威视技术股份有限公司 京ICP备13052921号-2',
    },
    live:{
        myLive: '我的直播',
        deleteLive: '删除直播间',
        roomName: '房间标题',
        roomNotice: '房间公告',
        inputName: '请输入房间标题',
        inputNotice: '请输入房间公告',
        isPassword: '是否需要密码',
        password: '密码',
        getAddress: '获取房间推流地址',
        liveInfo: '直播信息',
        rtmp: 'rtmp地址',
        liveCode: '直播码',
        tip: '注',
        tip1: '每次点击获取推流码都会重新生成直播码，每个直播码的有效期为5分钟。',
        tip2: '只有切换推流线路才会导致rtmp地址发生变化',
        startEndTime: '请选择开始时间和结束时间',
        copy: '复制',
        copyFail: '复制失败！',
        creator: '主播',
        onlineNum: '在线人数',
        notStart: '主播还未开播哦',
        left: '主播已经离开',
        refresh: '刷新直播状态',
        notice: '公告',
        noNotice: '暂无公告',
        chat: '聊天',
        audience: '观众',
        someFlowers: '这场直播能赏几朵花？',
        send: '发送',
        internetError: '网络错误，请检查网络，切换线路或清晰度',
        living: '直播中',
        noLive: '暂时没有直播哦',
        inputRoomPwd: '请输入房间密码',
        mainLine: '主线路',
        overseasLine: '海外线路',
        foldComments: '折叠评论',
        unfoldComments: '展开评论',
        reload: '重新载入',
    }
}
